<div class="flex flex-wrap w-full mt-8 mb-6">

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        <div class="flex gap-2 justify-center">
            @if (group?.memberStatus == membershipStatus.active && ((myRoles$ |
            async)?.management || (myRoles$ |
            async)?.faculty)) {
            <!-- <div class="flex flex-no-wrap justify-end gap-2">
                <app-btn-action label="New Lesson" (clicked)="onNewLesson()" icon="fa fa-add"
                    bgColor="bg-primary-500 hover:bg-primary-300"></app-btn-action>
            </div> -->
            <app-btn-route routeTo="create" colors="bg-primary-500 hover:bg-primary-300" textColor="text-white"
                icon="fa fa-add" btnText="New Lesson"></app-btn-route>
            }
        </div>
    </div>

    <div class="border-0 w-full mb-4">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            Lessons
        </h1>
    </div>

    @let isSearching = (isSearching$ | async);
    @let showingSearchResults = (showingSearchResults$ | async);

    <list-utils-bar (valueChanged)="onSearchTermChange($event)" [isSearching]="isSearching$"
        [showingResults]="showingSearchResults$" (onSearch)="onSearch($event)" (onCancel)="onCancelSearch()"
        [advancedSearchEnabled]="true" (onRefresh)="onRefresh()" (onAdvancedSearch)="onAdvancedSearch()"
        (onCancelAdvancedSearch)="onCancelAdvancedSearch()" class="w-full">

        <form [formGroup]="advSearchForm" (ngSubmit)="advSearch()"
            class="w-80 sm:w-96 md:w-[480px] p-2 flex flex-col gap-4">
            <!-- Search Title input -->
            <div class="flex flex-col gap-1">
                <label class="text-xs font-bold uppercase tracking-wider text-primary-400">Search Title</label>
                <div
                    class="flex flex-row items-center border border-primary-200 focus-within:border-primary-500 focus-within:ring-1 focus-within:ring-primary-500 rounded bg-white px-3 transition-all duration-150">
                    <i class="fas fa-search text-primary-300 mr-2 text-sm"></i>
                    <input type="text" formControlName="searchTerm" autocomplete="off"
                        placeholder="Search by lesson name..."
                        class="border-0 outline-none focus:outline-none focus:ring-0 placeholder:text-sm placeholder:italic placeholder-primary-200 text-primary-700 text-sm grow w-full p-0" />
                </div>
            </div>

            <!-- Filters Grid -->
            <div class="flex flex-col gap-3 border-t border-gray-100 pt-3">
                <span class="text-xs font-bold uppercase tracking-wider text-primary-400">Filters</span>

                <!-- Age Range Filters -->
                <div class="flex flex-col gap-1.5 bg-gray-50 rounded-lg p-3 border border-gray-100"
                    formGroupName="gradeAge">
                    <label class="text-xs font-semibold text-primary-600">Filter Grades By Age</label>
                    <div class="flex flex-row gap-3 items-center">
                        <div class="relative w-full">
                            <input type="text" placeholder="From Age" formControlName="fromAge"
                                class="border border-primary-200 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 rounded px-3 py-1 outline-none text-sm text-primary-700 placeholder:text-primary-200 placeholder:text-sm placeholder:italic w-full transition-all duration-150" />
                        </div>
                        <span class="text-xs text-primary-300 font-semibold">to</span>
                        <div class="relative w-full">
                            <input type="text" placeholder="To Age" formControlName="toAge"
                                class="border border-primary-200 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 rounded px-3 py-1 outline-none text-sm text-primary-700 placeholder:text-primary-200 placeholder:text-sm placeholder:italic w-full transition-all duration-150" />
                        </div>
                    </div>
                </div>

                <!-- Grade Checklist -->
                <div class="flex flex-col gap-2 bg-gray-50 rounded-lg p-3 border border-gray-100">
                    <div class="flex flex-row justify-between items-center border-b border-gray-200 pb-1.5">
                        <label class="text-xs font-semibold text-primary-600">Filter By Grade</label>
                        <button type="button" (click)="clearGradeFilters()"
                            class="text-xs text-primary-500 hover:text-primary-700 underline focus:outline-none transition-colors duration-150">
                            Clear All
                        </button>
                    </div>
                    <div formArrayName="selectedGrades" class="grid grid-cols-2 gap-2 max-h-40 overflow-y-auto pr-1">
                        @for (item of (grades$ | async) ?? []; track $index; let i = $index) {
                        <div
                            class="flex items-center gap-2 hover:bg-gray-100 p-1 rounded transition-colors duration-150">
                            <input type="checkbox" [formControlName]="i" [id]="'grade-checkbox-' + i"
                                class="rounded border-primary-200 text-secondary-500 focus:ring-0 focus:ring-offset-0 focus:outline-none h-4 w-4 transition duration-150" />
                            <label [for]="'grade-checkbox-' + i"
                                class="text-xs text-primary-600 cursor-pointer select-none">
                                {{item.gradeName}} ({{item.gradeAvgAge}})
                            </label>
                        </div>
                        }
                    </div>
                </div>
            </div>

            <!-- Actions Row -->
            <div class="flex flex-row gap-2 w-full mt-1">
                <app-btn-action label="Clear All" [shadow]="false"
                    bgColor="bg-transparent hover:bg-gray-100 border border-gray-200"
                    textColor="text-primary-500 hover:text-primary-700" class="w-[30%] block" [fullWidth]="true"
                    (clicked)="clearAllFilters()">
                </app-btn-action>
                <app-btn-submit actionText="Search"
                    [isDisabled]="advSearchForm.invalid || isSearchFormEmpty || ((isSearching$ | async) ?? false)"
                    [isLoading]="(isSearching$ | async) ?? false" class="w-[70%] block" [fullWidth]="true">
                </app-btn-submit>
            </div>
        </form>

    </list-utils-bar>

    <div class="w-full mb-4">
        <!-- <div class="rounded-t hidden w-full overflow-x-auto lg:block shadow-lg rounded bg-white"> -->
        @let loadingLessons = (loadingLessons$ | async) ?? false;

        <div class="w-full flex flex-col gap-4">

            @for (item of displayedLessons; track item.id) {
            <div #itemRef [attr.data-id]="item.id"
                class="flex flex-row justify-between bg-white shadow-lg rounded w-full px-4 py-3"
                [class.bg-yellow-400]="item.id === firstNewItemId">

                <div class="flex flex-row gap-4 justify-start">
                    @if(item.notesType == notesType.pdf) {
                    <a [href]="item.notesUrl || null" class="flex flex-row justify-start gap-4"
                        [attr.target]="item.notesUrl ? '_blank' : null"
                        [attr.rel]="item.notesUrl ? 'noopener noreferrer' : null">
                        <div
                            [class]="item.notesUrl ? 'text-blue-500 hover:underline' : 'text-gray-400 cursor-not-allowed'">
                            <i class="far fa-file-pdf text-lg"></i>
                        </div>
                    </a>
                    } @else if(item.notesType == undefined || item.notesType == notesType.text) {
                    <a [routerLink]="[item.id]" class="flex flex-row justify-start gap-4">
                        <div
                            [class]="item.notesUrl ? 'text-blue-500 hover:underline' : 'text-gray-400 cursor-not-allowed'">
                            <i class="far fa-file-lines text-lg"></i>
                        </div>
                    </a>
                    }
                    <div class="flex flex-col gap-2">
                        @if(item.notesType == notesType.pdf) {
                        <a [href]="item.notesUrl || null" [attr.target]="item.notesUrl ? '_blank' : null"
                            [attr.rel]="item.notesUrl ? 'noopener noreferrer' : null">
                            <ng-container *ngTemplateOutlet="sharedContent"></ng-container>
                        </a>
                        } @else if(item.notesType == undefined || item.notesType == notesType.text) {
                        <a [routerLink]="[item.id]">
                            <ng-container *ngTemplateOutlet="sharedContent"></ng-container>
                        </a>
                        }
                        <ng-template #sharedContent>
                            <div class="flex flex-col justify-start">
                                <span class="text-primary-300 text-xs whitespace-nowrap">
                                    {{ item.created | moment: 'Do MMM YYYY' }}
                                </span>
                                <div class="inline-flex flex-wrap items-center">
                                    <p class="font-semibold mr-1">
                                        {{ item.lessonName }}
                                    </p>
                                    <app-btn-chip [label]="item.lessonStatus ?? lessonStatus.unavailable"
                                        class="inline-flex"
                                        [color]="item.lessonStatus == lessonStatus.available ? 'text-green-700' : 'text-primary-500'"
                                        [bgColor]="item.lessonStatus == lessonStatus.available ? 'bg-green-50' : 'bg-gray-100'">
                                    </app-btn-chip>
                                </div>
                                <div class="flex flex-row gap-2">
                                    <p class="text-sm text-primary-300">{{ (getGradeName(item.gradeId) | async) ?? '' }}
                                        Age: {{
                                        item.avgAge }}
                                    </p>
                                </div>
                            </div>
                        </ng-template>
                        @if ((item.tags ?? []).length > 0) {
                        <div class="flex flex-row gap-2">
                            @for (item of item.tags; track $index) {
                            <p class="text-xs text-primary-300">#{{ item }}</p>
                            }
                        </div>
                        }
                        <div class="flex flex-row justify-start items-center gap-2">
                            <p class="text-sm text-blueGray-600">{{item.createdBy}}</p>
                        </div>
                    </div>
                </div>

                @let roles = (myRoles$ | async);

                @if(roles?.management || roles?.faculty) {
                <div class="flex flex-col">
                    <div class="relative flex md:hidden justify-end">
                        <app-btn-fab (click)="toggleDropdown(item.id!, $event)" #btnDropdownRef
                            icon="fas fa-ellipsis-vertical"></app-btn-fab>
                        <div class="absolute right-0 top-full mt-1 min-w-48 z-50 {{ activeDropdownLessonId === item.id ? 'block' : 'hidden'}}"
                            #popoverDropdownRef>
                            <div
                                class="bg-white text-base py-2 list-none text-left rounded shadow-lg min-w-48 border border-gray-100">
                                <a (click)="onAddToGrade(item)" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                                                            text-blueGray-700">
                                    <i class="fas fa-bullhorn mr-2 leading-relaxed"></i>
                                    Add to Grade
                                </a>
                                @if ((myRoles$ | async)?.faculty) {
                                <a (click)="onEditLesson(item)" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700"><i class="fas fa-chalkboard-user mr-2 leading-relaxed"></i>
                                    Edit Lesson
                                </a>
                                }

                                @if(roles?.management || (roles?.faculty && item.createdById == user?.uid)) {
                                <a (click)="onDeleteLesson(item)" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                        text-blueGray-700">
                                    <i class="fas fa-gear mr-2 leading-relaxed"></i>
                                    Delete Lesson
                                </a>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="hidden md:flex flex-row gap-2 whitespace-nowrap">
                        <app-btn-fab (click)="onAddToGrade(item)" icon="fas fa-add"
                            [isDisabled]="item.notesUrl == undefined || item.lessonStatus == lessonStatusType.unavailable"
                            tooltip="Add to Grade"></app-btn-fab>
                        <app-btn-fab (click)="onEditLesson(item)" icon="fas fa-edit"
                            tooltip="Update Lesson"></app-btn-fab>
                        @if(roles?.management || (roles?.faculty && item.createdById == user?.uid)) {
                        <app-btn-fab (click)="onDeleteLesson(item)" icon="fa fa-trash-can"
                            textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                        }
                    </div>
                </div>
                }
            </div>
            } @empty {
            @if(!loadingLessons) {
            <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
                No Lessons Found
            </div>
            }
            }
            @if(loadingLessons) {
            <div class="bg-white shadow-lg rounded p-4 mt-1 w-full mx-auto">
                <div class="animate-pulse flex space-x-4">
                    <div class="flex-1 space-y-2">
                        <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
                        <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
                        <div class="space-y-2">
                            <div class="grid grid-cols-3 gap-4 mb-2">
                                <div class="h-4 bg-slate-200 rounded col-span-2"></div>
                                <div class="h-4 bg-slate-200 rounded col-span-1"></div>
                            </div>
                            <div class="flex flex-row gap-2 justify-start items-center">
                                <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
                                <div class="h-4 w-1/4 bg-slate-200 rounded"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>

        @let canShowMore = !isSearching && (showingSearchResults ? hasMoreSearchResults : hasMoreLessons);
        @if (canShowMore && (displayedLessons?.length ?? 0) > 0) {
        <div class="flex flex-row w-full justify-center px-4 mt-3">
            <app-btn-more (click)="addMoreLessons()" [inProgress$]="isLoadingMore$"
                [isDisabled]="loadingLessons || isLoadingMore || user?.uid == null || groupId == null"></app-btn-more>
        </div>
        }
    </div>
</div>